import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Entry } from "contentful";
import { ContentfulService } from "../contentful.service";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"]
})
export class ProductComponent implements OnInit {
  categoryId: any;
  sub: any;
  productsArray: any;
  show;

  selectedProduct: any;

  constructor(
    private route: ActivatedRoute,
    private contentful: ContentfulService
  ) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.categoryId = params["category"];
      console.log(params);
      console.log(this.categoryId);

      if(this.categoryId === 'everything'){

        this.contentful.getProducts()
        .then(products => this.productsArray = products);
        console.log(this.productsArray);
      }else{
        this.contentful
        .getProductsByCategory(this.categoryId)
        .then(items => (this.productsArray = items));
      }


      console.log(this.productsArray);
    });
  }

  showEvent(selectedItem) {
    this.show = true;
    this.selectedProduct = selectedItem;
    console.log(this.selectedProduct);
  }
  closeEvent() {
    this.show = false;
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/product/product.component.ts